import type { DateValue, RangeValue } from '@heroui/react';
import { EProductType } from '@quesmed/types/models';
import { create } from 'zustand';
import { EDateFilter } from '@/config';
import type { OmitFunctions } from '@/types';
import { getDateRange } from '@/utils';
import { createSelectors } from './selector';

interface FeedbackState {
  productId: EProductType;
  rating: number | null;
  hasDescription: boolean;
  dateFilter: EDateFilter;
  range: { from: Date | null | number; to: Date | null | number };
  dateRange: RangeValue<DateValue> | undefined;
  isFilterDrawerOpen: boolean;
  isLoading: boolean;

  setProductId: (productId: EProductType) => void;
  setRating: (rating: number | null) => void;
  setHasDescription: (hasDescription: boolean) => void;
  setDateFilter: (dateFilter: EDateFilter) => void;
  setIsFilterDrawerOpen: (isOpen: boolean) => void;
  setIsLoading: (isLoading: boolean) => void;
  setRange: (range: FeedbackState['range']) => void;
  setDateRange: (dateRange: FeedbackState['dateRange']) => void;
  reset: () => void;
}

const initialState: OmitFunctions<FeedbackState> = {
  productId: EProductType.ALL,
  rating: null,
  hasDescription: false,
  dateFilter: EDateFilter.THIS_MONTH,
  range: getDateRange(EDateFilter.THIS_MONTH),
  dateRange: undefined,
  isFilterDrawerOpen: false,
  isLoading: false,
};

export const feedbackState = create<FeedbackState>()((set) => ({
  ...initialState,
  setProductId: (productId) => set({ productId }),
  setRating: (rating) => set({ rating }),
  setHasDescription: (hasDescription) => set({ hasDescription }),
  setDateFilter: (dateFilter) => set({ dateFilter }),
  setIsFilterDrawerOpen: (isOpen) => set({ isFilterDrawerOpen: isOpen }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setRange: (range) => set({ range }),
  setDateRange: (dateRange) => set({ dateRange }),
  reset: () => set(initialState),
}));

export const useFeedbackState = () => feedbackState((state) => state);
export const useFeedback = createSelectors(feedbackState);
